module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc-chapb"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/9780226181608_07_ack#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226181608_08_int#int"
    }
  }, [_vm._v("Introduction: War, Money, and American History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226181608_09_ch1#ch1"
    }
  }, [_vm._v("1. A More Effectual Mode of Administration: The Constitution and the Origins of American Public Finance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226181608_10_ch2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Soul of Government: Creating an American Fiscal Regime")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226181608_11_ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. So Immense a Power in the Affairs of War: The Restoration of Public Credit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226181608_12_ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Equal to the Severest Trials: Mr. Madison’s War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226181608_13_ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Two Most Powerful Republics in the World: Mr. Polk’s War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226181608_14_ch6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. A Rank among the Very First of Military Powers: Mr. Lincoln’s War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226181608_15_con#con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: The Ideology, Structure, and Significance of the First American Fiscal Regime")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226181608_16_not#not",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226181608_17_ind#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52448b70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226181608_06_toc.vue
// module id = 72
// module chunks = 0